const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];
const STORE = "btk_attribution";

export function captureAttribution() {
  try {
    const existing = JSON.parse(sessionStorage.getItem(STORE) || "null");
    const params = new URLSearchParams(window.location.search);
    const fresh = {};
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) fresh[k] = v;
    });
    const data = {
      ...(existing || {
        landing_page_url: window.location.href,
        referrer_url: document.referrer || "",
        first_page_timestamp: new Date().toISOString(),
      }),
      ...fresh,
    };
    sessionStorage.setItem(STORE, JSON.stringify(data));
    return data;
  } catch {
    return {
      landing_page_url: window.location.href,
      referrer_url: document.referrer || "",
      first_page_timestamp: new Date().toISOString(),
    };
  }
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(STORE)) || captureAttribution();
  } catch {
    return captureAttribution();
  }
}
